import { render, staticRenderFns } from "./merge_request_statistics.vue?vue&type=template&id=63e88a16"
import script from "./merge_request_statistics.vue?vue&type=script&lang=js"
export * from "./merge_request_statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports